<template>
  <section class="section-service col-12">
    <q-option-group
      hidden
      v-model="panel"
      inline
      :options="[
        { label: 'Tab-1', value: 'tab-1' },
        { label: 'Tab-2', value: 'tab-2' },
      ]"
    />

    <q-tab-panels
      v-model="panel"
      class="panel-services"
    >
      <q-tab-panel
        name="tab-1"
        class="col-12 row items-center justify-center"
      >
        <q-form ref="formtab1">
          <div class="group-input col-12 row q-mt-sm">
            <label for="os_number">Número da OS</label>
            <q-input
              id="os_number"
              ref="osNumberRef"
              v-model="requestData.osNumber"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="10"
              color="red-9"
              dense
              outlined
              mask="##########"
              unmasked-value
              placeholder="0000000000"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>
          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Tipo de OS</label>
            <q-select
              id="type-os"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="typeOSRef"
              v-model="requestData.typeOS"
              color="red-9"
              use-input
              @filter="filterTypeOS"
              @update:model-value="onChangeTypeOs"
              hide-selected
              fill-input
              input-debounce="0"
              :options="displayListTypeOS"
              option-value="value"
              option-label="text"
              bg-color="white"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>
          <div class="group-input col-12 row q-mt-sm">
            <label for="os_action">Ação</label>
            <q-select
              id="os_action"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="osActionRef"
              v-model="requestData.action"
              emit-value
              color="red-9"
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="optionsActionOs"
              map-options
              option-value="id_acao"
              option-label="desc_acao"
              bg-color="white"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>

          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Estado</label>
            <q-select
              id="state-os"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="stateOSRef"
              v-model="requestData.state"
              color="red-9"
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="optionsStateEquipaments"
              emit-value
              map-options
              option-value="id_estado_equipamento"
              option-label="desc_estado_equipamento"
              bg-color="white"
              disable
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>
          <!-- <div class="group-input col-12 row q-mt-sm">
            <label>Status da OS</label>
            <div class="col-12 row flex justify-around q-mt-sm">
              <q-btn-toggle
                disable
                v-model="requestData.statusOS"
                spread
                class="col-12"
                no-caps
                rounded
                toggle-color="red-6"
                color="gray-8"
                text-color="white"
                :options="[
                  { label: 'Executada', value: 1 },
                  { label: 'Não Executada', value: 0 },
                ]"
              />
            </div>
          </div> -->
          <div class="group-input col-12 row q-mt-lg">
            <label for="write-off-code">Código de Baixa</label>
            <q-select
              id="write-off-code"
              class="col-12 q-mt-sm"
              outlined
              dense
              ref="writeOffCodeRef"
              v-model="requestData.writeOffCode"
              color="red-9"
              @filter="filterWriteOffCode"
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="optionsItens.optionsWriteOffCode"
              option-value="value"
              option-label="text"
              bg-color="white"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
            />
            <!-- <q-checkbox keep-color dense
              @click.native="openConfirmationReplicateWriteOffCode" color="red">
              <template v-slot:default>
                <label class="label-checkbox-confirm">
                  Replicar código de baixa para as próximas solicitações.
                </label>
              </template>
            </q-checkbox> -->
            <DialogCardsOsAvailableReplicate
              :listOsRequest="
                contract.osRequests.filter((element) => {
                  return element.osNumber != requestData.osNumber;
                })
              "
              :show="modalReplicateWriteOffCode"
              @replicateWriteOffCode="replicateWriteOffCode"
              @cancelReplicate="cancelReplicate"
            >
            </DialogCardsOsAvailableReplicate>
          </div>
          <div class="group-input col-12 row q-mt-md">
            <label for="observation">Observação</label>
            <div class="col-12 row flex justify-around">
              <q-input
                v-model="requestData.observation"
                class="col-12 q-mt-sm"
                bg-color="white"
                color="red-9"
                maxlength="300"
                outlined
                autogrow
                :rules="[(val) => !!val || 'Campo Obrigatório']"
              />
            </div>
          </div>
        </q-form>
      </q-tab-panel>

      <q-tab-panel
        name="tab-2"
        class="col-12 row items-center justify-center"
      >
        <q-form ref="formtab2">
          <div
            class="group-input col-12 row q-mt-sm"
            v-if="isShownInstalledField"
          >
            <label for="os_install_number">Número equipamento instalado</label>
            <q-input
              id="os_install_number"
              ref="osInstallNumberRef"
              v-model="requestData.equipamentNumberInstall"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="20"
              color="red-9"
              dense
              outlined
              type="text"
              unmasked-value
              placeholder="0000000000"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
              @blur="
                openDialogEquipament(
                  'Confirma numeração do equipamento instalado?'
                )
              "
            />
          </div>
          <div
            class="group-input col-12 row q-mt-sm"
            v-if="isShownUninstalledField"
          >
            <label for="os_desinstall_number"
              >Número equipamento desinstalado</label
            >
            <q-input
              id="os_desinstall_number"
              ref="osDesinstallNumberRef"
              v-model="requestData.equipamentNumberDesinstall"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="20"
              color="red-9"
              dense
              outlined
              type="text"
              unmasked-value
              placeholder="0000000000"
              :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
              lazy-rules
              @blur="
                openDialogEquipament(
                  'Confirma numeração do equipamento desinstalado?',
                  false
                )
              "
            />
          </div>
          <div class="group-input col-12 row q-mt-md">
            <label for="type-os">Foi necessário movimentar o smartcard?</label>
            <div class="col-12 row flex justify-around">
              <q-radio
                keep-color
                v-model="requestData.IsDecoderComum"
                :val="1"
                size="lg"
                label="Sim"
                color="red-6"
              />
              <q-radio
                keep-color
                v-model="requestData.IsDecoderComum"
                :val="0"
                size="lg"
                label="Não"
                color="red-6"
              />
            </div>
          </div>
          <div
            class="group-input col-12 row q-mt-sm"
            v-show="requestData.IsDecoderComum == 1"
          >
            <label for="os_number"
              >Informe o número do SMARTCARD instalado</label
            >
            <q-input
              id="os_number"
              ref="cardNumberRef"
              v-model="requestData.cardNumberInstaled"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="12"
              color="red-9"
              dense
              outlined
              unmasked-value
              type="text"
              placeholder="0000000000"
              lazy-rules
            />
          </div>
          <div
            class="group-input col-12 row q-mt-sm"
            v-show="requestData.IsDecoderComum == 1"
          >
            <label for="os_number"
              >Informe o Número do SMARTCARD desinstalado</label
            >
            <q-input
              id="os_number"
              ref="cardNumberRef"
              v-model="requestData.cardNumberUninstalled"
              class="col-12 q-mt-sm"
              bg-color="white"
              maxlength="12"
              color="red-9"
              dense
              outlined
              type="text"
              unmasked-value
              placeholder="0000000000"
              lazy-rules
            />
          </div>
        </q-form>
      </q-tab-panel>
    </q-tab-panels>
    <section>
      <div>
        <q-footer>
          <q-toolbar elevated>
            <div
              class="flex col-12 row items-center justify-between"
              v-if="panel != 'tab-2'"
            >
              <div
                class="col-8 div-progress q-pa-sm justify-center flex items-center"
              >
                <q-linear-progress
                  size="md"
                  :value="progressBar"
                  color="red-9"
                  rounded
                />
              </div>
              <div class="col-2 div-btn-next justify-center flex items-center">
                <q-btn
                  round
                  color="red-9"
                  @click="addValueBarProgressAndAlterTab()"
                  icon="arrow_forward"
                />
              </div>
            </div>
            <div
              class="flex col-12 row items-center justify-between"
              v-else
            >
              <div class="col-4 justify-center flex items-center">
                <q-btn
                  unelevated
                  outline
                  rounded
                  color="red-9"
                  @click="$emit('removeEdit')"
                  label="Cancelar"
                />
              </div>
              <div class="col-4 justify-center flex items-center">
                <q-btn
                  unelevated
                  rounded
                  color="red-9"
                  @click="validateForm()"
                  label="Concluir"
                />
              </div>
            </div>
          </q-toolbar>
        </q-footer>
      </div>
    </section>
  </section>
</template>

<script>
  import DateTimePicker from "@/components/DateTimePicker";
import DialogCardsOsAvailableReplicate from "@/components/DialogCardsOsAvailableReplicate";
import SelectCheckbox from "@/components/SelectCheckbox";
import { filterListByText } from "@/helpers/filterHelper";
import moment from "moment";
import { useQuasar } from "quasar";
import { computed, onMounted, reactive, ref } from "vue";

  export default {
    name: "FormOsProductionRquest",
    components: {
      DialogCardsOsAvailableReplicate,
      SelectCheckbox,
      DateTimePicker,
    },
    props: {
      listWriteOffCode: Array,
      listTypeOS: Array,
      optionsWriteOffCode: Array,
      optionsTypeOS: Array,
      optionsTypeOSByClassification: Array,
      optionsActionOs: Array,
      optionsStateEquipaments: Array,
      itemOsContract: Object,
    },
    emits: [
      "saveSchemaRequest",
      "clearSchemaRequest",
      "removeEdit",
      "getTypeOsClassification",
      "getWriteOffCodeByTypeOs",
      "selectTypeOs",
    ],

    setup(props, { emit }) {
      moment.locale("pt-br");

      const $q = useQuasar();

      const actionMapper = {
        TROCA_TERMINAL: 1,
        ENTREGA_TERMINAL: 2,
        DEVOLUCAO_TERMINAL: 3,
      };

      let panel = ref("tab-1");
      let tabindex = ref(1);
      let progressBar = ref(0.5);

      const isShownInstalledField = computed(() => {
        return (
          requestData.action == actionMapper.TROCA_TERMINAL ||
          requestData.action == actionMapper.ENTREGA_TERMINAL
        );
      });

      const isShownUninstalledField = computed(() => {
        return (
          requestData.action == actionMapper.TROCA_TERMINAL ||
          requestData.action == actionMapper.DEVOLUCAO_TERMINAL
        );
      });

      let requestData = reactive({
        object_id: "",
        osNumber: "",
        typeOS: "",
        statusOS: 1,
        writeOffCode: "",
        observation: "",
        check: false,
        replicate: false,
        source: "",
        action: 0,
        state: 1,
        equipamentNumberInstall: "",
        equipamentNumberDesinstall: "",
        IsDecoderComum: 1,
        cardNumberInstaled: "",
        cardNumberUninstalled: "",
      });

      let contract = reactive({
        osRequests: [],
      });
      let confirmationReplicateWriteOffCode = ref(false);
      let modalReplicateWriteOffCode = ref(false);

      let schemaRequest = reactive({
        object_id: "",
        osNumber: "",
        typeOS: "",
        statusOS: 1,
        writeOffCode: "",
        observation: "",
        check: false,
        replicate: false,
        source: "",
        action: 1,
        state: 1,
        equipamentNumberInstall: "",
        equipamentNumberDesinstall: "",
        cardNumberInstaled: "",
        cardNumberUninstalled: "",
      });
      const formtab1 = ref(null);
      const formtab2 = ref(null);

      const displayListTypeOS = ref(props.optionsTypeOSByClassification);
      const listWriteOffCode = ref([]);

      const optionsItens = reactive({
        optionsTypeOS: displayListTypeOS,
        optionsWriteOffCode: listWriteOffCode,
      });

      function filterTypeOS(val, update) {
        update(() => {
          displayListTypeOS.value = filterListByText(
            props.optionsTypeOSByClassification,
            val,
            "text"
          );
        });
      }

      function filterWriteOffCode(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          optionsItens.optionsWriteOffCode = props.listWriteOffCode.filter(
            (v) => v.text.toLowerCase().indexOf(needle) > -1
          );
        });
      }

      const onChangeTypeOs = (typeOs) => {
        emit("selectTypeOs", typeOs.value);
        requestData.action = 0;
      };

      function _getClassificationTypeName() {
        switch (requestData.action) {
          case 1:
            return "MANUTENÇÃO";
          case 2:
            return "INSTALAÇÃO";
          case 3:
            return "SERVIÇO";
        }
      }

      function modalDialogConfirmarDeleteSchemaOsRequest() {
        $q.dialog({
          title: `Deletar OS ${props.itemOsContract.osNumber}`,
          message: `Atenção! Após deletar a OS, não há uma forma de reverter. Tem certeza que deseja deletar a OS selecionada?`,
          cancel: true,
          persistent: true,
          position: "bottom",
        })
          .onOk(() => {
            deleteSchemaRequest(props.itemOsContract.object_id);
          })
          .onCancel(() => {});
      }

      function openConfirmationReplicateWriteOffCode() {
        if (requestData.writeOffCode == "") {
          confirmationReplicateWriteOffCode.value = false;
          $q.notify({
            message: "Selecione pelo menos um código baixa antes de replicar.",
            color: "red-9",
            position: "top",
          });
          return;
        }

        if (confirmationReplicateWriteOffCode.value == true) {
          modalReplicateWriteOffCode.value = true;
        } else {
          cancelReplicate();
        }
      }

      function openDialogEquipament(item, isInstall = true) {
        $q.dialog({
          title: "Confirme a numeração",
          message: item,
          cancel: true,
        })
          .onOk(() => {})
          .onCancel(() => {
            if (isInstall) {
              requestData.equipamentNumberInstall = "";
            } else {
              requestData.equipamentNumberDesinstall = "";
            }
          });
      }

      async function validateForm() {
        let validation = false;

        if (progressBar.value == 1.0) {
          validation = await formtab2.value.validate();
          if (validation) {
            await emitData();
          }
        } else {
          validation = await formtab1.value.validate();
        }
        return validation;
      }

      async function emitData() {
        emit("saveSchemaRequest", returnSchemaRequest());
      }

      function replicateWriteOffCode() {
        for (let item of contract.osRequests) {
          if (
            item.osNumber !== requestData.osNumber &&
            item.replicate === true
          ) {
            item.writeOffCode = requestData.writeOffCode;
          }
        }
        confirmationReplicateWriteOffCode.value = true;
        modalReplicateWriteOffCode.value = false;
      }

      function cancelReplicate() {
        confirmationReplicateWriteOffCode.value = false;
        for (let item of contract.osRequests) {
          item.replicate = false;
        }
      }

      function returnSchemaRequest() {
        let schemaRequest = {
          object_id: requestData.object_id,
          osNumber: requestData.osNumber,
          typeOS: requestData.typeOS,
          statusOS: requestData.statusOS,
          writeOffCode: requestData.writeOffCode,
          observation: requestData.observation,
          check: true,
          replicate: requestData.replicate,
          source: requestData.source,
          action: requestData.action,
          state: requestData.state,
          equipamentNumberInstall: requestData.equipamentNumberInstall,
          equipamentNumberDesinstall: requestData.equipamentNumberDesinstall,
          cardNumberInstaled: requestData.cardNumberInstaled,
          cardNumberUninstalled: requestData.cardNumberUninstalled,
        };

        return schemaRequest;
      }

      function validateSchemaRequest() {
        if (
          requestData.osNumber == "" ||
          requestData.writeOffCode == "" ||
          requestData.typeOS == "" ||
          requestData.observation == ""
        ) {
          $q.notify({
            message: "Todos os campos são obrigatórios.",
            color: "red-9",
            position: "top",
            timeout: 3000,
          });
          return false;
        }
        return true;
      }

      function _createOsRequestData() {
        requestData.osNumber =
          props.itemOsContract.data.osNumber ?? requestData.osNumber;
        requestData.object_id =
          props.itemOsContract.data.object_id ?? requestData.object_id;
        requestData.typeOS =
          props.itemOsContract.data.typeOS ?? requestData.typeOS;
        requestData.writeOffCode =
          props.itemOsContract.data.writeOffCode ?? requestData.writeOffCode;
        requestData.statusOS = 1;
        requestData.observation =
          props.itemOsContract.data.observation ?? requestData.observation;
        requestData.check = false;
        requestData.replicate = false;
        requestData.source = "NetSMS" ?? requestData.source;
        requestData.action =
          props.itemOsContract.data.action ?? requestData.action;
        requestData.state =
          props.itemOsContract.data.state ?? requestData.state;
        requestData.equipamentNumberInstall =
          props.itemOsContract.data.equipamentNumberDesinstall ??
          requestData.equipamentNumberInstall;
        requestData.equipamentNumberDesinstall =
          props.itemOsContract.data.equipamentNumberInstall ??
          requestData.equipamentNumberDesinstall;
        requestData.IsDecoderComum =
          props.itemOsContract.data.cardNumber != null ? 1 : 0;
        requestData.cardNumber =
          props.itemOsContract.data.cardNumber ?? requestData.cardNumber;
        requestData.cardNumberInstaled =
          props.itemOsContract.data.cardNumberInstaled ??
          requestData.cardNumberInstaled;
        requestData.cardNumberUninstalled =
          props.itemOsContract.data.cardNumberUninstalled ??
          requestData.cardNumberUninstalled;
      }

      function _changeTab() {
        const VALUE_INCREMENT_ID_TAB = 1;
        const STRING_ID_TAB = "tab-";

        tabindex.value += VALUE_INCREMENT_ID_TAB;
        panel.value = STRING_ID_TAB + tabindex.value;

        return true;
      }

      async function addValueBarProgressAndAlterTab() {
        const VALUE_MAX_BAR_PROGRESS = 1;
        const VALUE_ADD_PROGRESS = 0.5;
        if (
          progressBar.value != VALUE_MAX_BAR_PROGRESS &&
          (await validateForm())
        ) {
          let validateIfChangeTab = _changeTab();

          if (validateIfChangeTab) {
            progressBar.value += VALUE_ADD_PROGRESS;
          }
        }
      }
      onMounted(() => {
        _createOsRequestData();
      });

      return {
        panel,
        tabindex,
        progressBar,
        schemaRequest,
        requestData,
        optionsItens,
        formtab1,
        formtab2,
        confirmationReplicateWriteOffCode,
        modalReplicateWriteOffCode,
        openConfirmationReplicateWriteOffCode,
        replicateWriteOffCode,
        cancelReplicate,
        contract,
        returnSchemaRequest,
        validateSchemaRequest,
        filterWriteOffCode,
        filterTypeOS,
        modalDialogConfirmarDeleteSchemaOsRequest,
        addValueBarProgressAndAlterTab,
        openDialogEquipament,
        validateForm,
        onChangeTypeOs,
        isShownUninstalledField,
        isShownInstalledField,
        displayListTypeOS,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
